import { useMemo, useRef } from 'react';

import createAgentMentionPlugin from 'components/text_editor_new/plugins/agent_mention/create_agent_mention_plugin';

// Creates the agent-mention plugins and the shared ref the plugin and the menu use to coordinate
// keyboard navigation. Spread `agentMentionPlugins` into the editor's plugin list and pass
// `menuActionsRef` to <AgentMentionMenu>.
export default function useCreateAgentMentionPlugin() {
  const menuActionsRef = useRef({ hasJustInsertedMention: false });

  const agentMentionPlugins = useMemo(() => createAgentMentionPlugin(menuActionsRef), []);

  return { agentMentionPlugins, menuActionsRef };
}
